import { FormControl } from '@mui/material';
import { action, makeObservable, observable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';
import AutoComplete from '../../../misc/AutoComplete';
import FiltroImportacaoStore from '../../../store/FiltroImportacaoStore';
import FiltroStore from '../../../store/FiltroStore';

interface IPropsFiltroOrgaoJudicante {
   importacao?: boolean;
}

class FiltroOrgaoJudicante extends React.Component<IPropsFiltroOrgaoJudicante> {
   importacaoLocal = false;

   constructor(props: IPropsFiltroOrgaoJudicante) {
      super(props);

      this.importacaoLocal = !!props.importacao;

      makeObservable(this, {
         importacaoLocal: observable,
         callback: action
      });
   }

   componentDidUpdate(prevProps: IPropsFiltroOrgaoJudicante) {
      if (prevProps.importacao !== this.props.importacao) {
         this.importacaoLocal = !!this.props.importacao;
      }
   }

   get store() {
      return this.importacaoLocal ? FiltroImportacaoStore : FiltroStore;
   }

   callback = (ev, valores) => {
      this.store.orgaoJudicanteSelecionadoFilter = [];
      valores.forEach(valor => {
         this.store.orgaoJudicanteSelecionadoFilter.push(valor.valor || valor);
      });
   };

   render() {
      return (
         <FormControl fullWidth className='formControlFiltros'>
            <AutoComplete
               multiple
               freeSolo
               callback={this.callback}
               options={this.store.ojAutoComplete}
               label='Órgão Julgador Colegiado'
               id='filtroOJ'
               defaultValue={this.store.ojAutoComplete.filter(
                  (item) => {
                     return this.store.orgaoJudicanteSelecionadoFilter?.find(oj => oj === item?.texto)
                  }
               )}
               white={true}
            />
         </FormControl>
      )
   }
}

export default observer(FiltroOrgaoJudicante);